import React from "react";
import pricingImg from "../assets/team.png";
import Navbar from "./Navbar";
import What from './What';
import Footer from './Footer'

const PricingPage = () => {
  return (
    <>
      <style>{`

        /* ================= HERO ================= */

        .hero {
          position: relative;
          height: 100vh;
          display: flex;
          align-items: center;
          color: white;
          overflow: hidden;
        }

        .hero::before {
          content: "";
          position: absolute;
          inset: 0;
          background: url(${pricingImg}) center/cover no-repeat;
          z-index: 1;
        }

        .hero::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(15, 61, 46, 0.9) 0%,
            rgba(15, 61, 46, 0.7) 40%,
            rgba(15, 61, 46, 0.3) 70%,
            rgba(15, 61, 46, 0.1) 100%
          );
          z-index: 2;
        }

        .hero-content {
          position: relative;
          z-index: 3;
          max-width: 600px;
          margin-left: 80px;
        }

        .hero h1 {
          font-size: 48px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 20px;
        }

        .hero p {
          font-size: 16px;
          color: #dcdcdc;
          margin-bottom: 25px;
        }

        .hero-btn {
          background: #7ED957;
          color: black;
          padding: 12px 22px;
          border: none;
          border-radius: 999px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
        }

        .hero-btn:hover {
          background: #D4AF37;
        }

        /* ================= PRICING ================= */

        .pricing-section {
          background: #EFFFE1;
          padding: 100px 20px;
          text-align: center;
        }

        .container {
          max-width: 1200px;
          margin: auto;
        }

        .heading {
          font-size: 36px;
          color: #0F3D2E;
          margin-bottom: 50px;
        }

        .pricing-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }

        .card {
          background: white;
          border-radius: 16px;
          padding: 30px 20px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.06);
          transition: 0.3s;
        }

        .card:hover {
          transform: translateY(-10px);
        }

        .highlight {
          background: #0F3D2E;
          color: white;
          transform: scale(1.05);
        }

        .highlight h3,
        .highlight p,
        .highlight li {
          color: white;
        }

        .card h3 {
          font-size: 22px;
          color: #0F3D2E;
          margin-bottom: 10px;
        }

        .price {
          font-size: 28px;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .desc {
          font-size: 14px;
          margin-bottom: 20px;
          color: #555;
        }

        .card ul {
          list-style: none;
          padding: 0;
          margin-bottom: 20px;
          text-align: left;
        }

        .card li {
          font-size: 14px;
          margin-bottom: 8px;
          color: #333;
        }

.btn {
  background: #7ED957;
  border: none;
  padding: 10px 18px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 300;

  text-decoration: none;   /* removes underline */
  display: inline-block;   /* makes <a> behave like button */
  color: black;            /* ensures text color */
}



        /* ================= RESPONSIVE ================= */

        @media (max-width: 1000px) {
          .pricing-grid {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (max-width: 768px) {
          .hero-content {
            margin-left: 20px;
            margin-right: 20px;
          }

          .hero h1 {
            font-size: 32px;
          }
        }

        @media (max-width: 600px) {
          .pricing-grid {
            grid-template-columns: 1fr;
          }
        }

      `}</style>

      <Navbar />

      {/* HERO */}
      <section className="hero">
        <div className="hero-content">

          <h1>
            Transparent Pricing <br />
            For Every Business Need
          </h1>

          <p>
            Explore our flexible pricing plans designed to support
            startups, professionals, and enterprises with complete
            tax and financial solutions.
          </p>

          <button className="hero-btn">
            View Plans ↗
          </button>

        </div>
      </section>

      {/* PRICING CARDS */}
      <section className="pricing-section">
        <div className="container">

          <h2 className="heading">
            Choose a Plan That’s Right for Your Business
          </h2>

          <div className="pricing-grid">

            <div className="card">
              <h3>Gold</h3>
              <div className="price">₹999 – ₹2999</div>
              <p className="desc">Basic compliance for individuals & startups</p>

              <ul>
                <li>GST Registration</li>
                <li>Basic GST Filing</li>
                <li>ITR Filing</li>
                <li>TDS Filing</li>
                <li>Basic Accounting</li>
              </ul>

              <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Gold%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

            <div className="card">
              <h3>Diamond</h3>
              <div className="price">₹2999 – ₹7999</div>
              <p className="desc">Advanced compliance & advisory</p>

              <ul>
                <li>GST + TDS Compliance</li>
                <li>Income Tax Audit</li>
                <li>Startup Advisory</li>
                <li>Monthly Compliance</li>
                <li>Business Strategy</li>
              </ul>

              <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Diamond%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

            <div className="card highlight">
              <h3>Platinum</h3>
              <div className="price">₹7999 – ₹25,000</div>
              <p className="desc">Strategic financial planning</p>

              <ul>
                <li>Corporate Tax Advisory</li>
                <li>Business Structuring</li>
                <li>Capital Gain Planning</li>
                <li>Virtual CFO</li>
                <li>Advanced GST Advisory</li>
              </ul>

               <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Diamond%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

            <div className="card">
              <h3>Enterprise</h3>
              <div className="price">Custom Pricing</div>
              <p className="desc">For large firms & HNI clients</p>

              <ul>
                <li>International Tax</li>
                <li>M&A Advisory</li>
                <li>Wealth Structuring</li>
                <li>IPO Advisory</li>
                <li>Full Financial Strategy</li>
              </ul>

             <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Gold%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

          </div>

        </div>
      </section>
      <What/>
<Footer/>
    </>
  );
};

export default PricingPage;